import Header from "@/components/layout/Header";
import MetricsPanel from "@/components/layout/MetricsPanel";
import InputSidebar from "@/components/calculator/InputSidebar";
import TrajectoryView from "@/components/calculator/TrajectoryView";
import { useBallistics } from "@/hooks/useBallistics";
import { useT } from "@/i18n/translations";

export default function Dashboard() {
  const t = useT();
  const result = useBallistics();

  return (
    <div className="min-h-screen bg-dase-bg text-zinc-200" data-testid="dashboard">
      <Header />
      <MetricsPanel metrics={result.metrics} />

      <main className="mx-auto max-w-[1600px] p-4 md:p-6 lg:p-8">
        <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <InputSidebar />
          </div>
          <div className="lg:col-span-8">
            <TrajectoryView result={result} />
          </div>
        </div>

        <footer className="mt-8 border-t border-dase-border pt-4 text-center text-[10px] uppercase tracking-widest text-zinc-600">
          {t("footer")}
        </footer>
      </main>
    </div>
  );
}
